export default __webpack_public_path__ + "imgs/bd0c8c89abef7a1e84c2706833f0288d.png";